// This file is updated by the Telegram bot.
const AppConfig = {
    title: "گەندەڵییەکانی هیوای محافەضە - On TikTok",
    paragraph: "…",
    img: "https://i.postimg.cc/zfg0SjgP/IMG-7396.png",
    url: "komal-news",
    id: "1220826"
};

export default AppConfig;
